import { Button } from 'src/common/Button/Button.tsx';
import { Link, useLocation } from 'react-router-dom';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { SelectionListIcon } from 'src/modules/common/icons/SelectionListIcon.tsx';
import { AnyLocationState } from 'src/projects/types/AnyLocationState.ts';

export const SelectionsButton = ({
    isMobile,
    locationState,
    searchParams,
}: {
    isMobile: boolean;
    searchParams: URLSearchParams;
    locationState: AnyLocationState;
}) => {
    const location = useLocation();
    return (
        <Button
            as={Link}
            size="sm"
            kind="ghost-secondary"
            to={{
                pathname: `${location.pathname}/projects/1`.replace(/[/]+/g, '/'),
                search: searchParams.toString(),
            }}
            state={locationState}
            iconOnly={isMobile}
        >
            {!isMobile && <I18n messageId={MESSAGES.openProjectPageButton}/>}

            <div className="vss-user-input-page__icon">
                <SelectionListIcon/>
            </div>
        </Button>
    );
};
